// Podgląd zdjęć z galerii: <dialog>, strzałki (także z klawiatury), Esc zamyka, przesunięcie palcem zmienia zdjęcie.
const ICON = {
    close: "<svg class=\"cc-icon\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M6.2 6.2 17.8 17.8\"/><path d=\"M17.8 6.2 6.2 17.8\"/></svg>",
    arrow: "<svg class=\"cc-icon\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M4.5 12h15\"/><path d=\"M13.4 5.9 19.5 12l-6.1 6.1\"/></svg>"
};

export function initLightbox() {
    const links = [...document.querySelectorAll("a[data-cc-lightbox]")];
    if (!links.length || typeof HTMLDialogElement === "undefined") {
        return;
    }

    const dialog = document.createElement("dialog");
    dialog.className = "cc-lightbox";
    dialog.setAttribute("aria-label", "Podgląd zdjęcia");
    dialog.innerHTML = `
        <figure class="cc-lightbox__figure">
            <img class="cc-lightbox__img" alt="">
            <figcaption class="cc-lightbox__caption"></figcaption>
        </figure>
        <p class="cc-lightbox__count" aria-live="polite"></p>
        <button type="button" class="cc-lightbox__btn cc-lightbox__close" aria-label="Zamknij podgląd">${ICON.close}</button>
        <button type="button" class="cc-lightbox__btn cc-lightbox__prev" aria-label="Poprzednie zdjęcie">${ICON.arrow}</button>
        <button type="button" class="cc-lightbox__btn cc-lightbox__next" aria-label="Następne zdjęcie">${ICON.arrow}</button>`;
    document.body.appendChild(dialog);

    const img = dialog.querySelector(".cc-lightbox__img");
    const caption = dialog.querySelector(".cc-lightbox__caption");
    const count = dialog.querySelector(".cc-lightbox__count");
    let group = [];
    let index = 0;
    let opener = null;

    const calm = window.matchMedia("(prefers-reduced-motion: reduce)");
    const show = (i, step = 0) => {
        index = (i + group.length) % group.length;
        const link = group[index];
        img.src = link.href;
        img.alt = link.querySelector("img")?.alt || "";
        caption.textContent = link.dataset.caption || "";
        count.textContent = `${index + 1} / ${group.length}`;
        if (step && !calm.matches) {
            // następne zdjęcie wjeżdża z kierunku strzałki
            img.animate([
                {opacity: 0, transform: `translateX(${step * 60}px) rotate(${step * 3}deg)`},
                {opacity: 1, transform: "none"}
            ], {duration: 420, easing: "cubic-bezier(.34,1.56,.64,1)"});
        }
    };

    links.forEach((link) => {
        link.addEventListener("click", (event) => {
            event.preventDefault();
            opener = link;
            group = links.filter((l) => l.dataset.ccLightbox === link.dataset.ccLightbox);
            dialog.classList.toggle("is-single", group.length < 2);
            show(group.indexOf(link));
            dialog.showModal();
            document.dispatchEvent(new CustomEvent("cc:scroll-lock", {detail: true}));
        });
    });

    dialog.querySelector(".cc-lightbox__close").addEventListener("click", () => dialog.close());
    dialog.querySelector(".cc-lightbox__prev").addEventListener("click", () => show(index - 1, -1));
    dialog.querySelector(".cc-lightbox__next").addEventListener("click", () => show(index + 1, 1));

    dialog.addEventListener("click", (event) => {
        if (event.target === dialog || event.target.classList.contains("cc-lightbox__figure")) {
            dialog.close();
        }
    });

    dialog.addEventListener("keydown", (event) => {
        if (event.key === "ArrowRight") {
            show(index + 1, 1);
        } else if (event.key === "ArrowLeft") {
            show(index - 1, -1);
        }
    });

    let touchX = null;
    dialog.addEventListener("touchstart", (event) => {
        touchX = event.touches[0].clientX;
    }, {passive: true});
    dialog.addEventListener("touchend", (event) => {
        if (touchX === null) {
            return;
        }
        const dx = event.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 50) {
            show(index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        }
        touchX = null;
    });

    dialog.addEventListener("close", () => {
        img.removeAttribute("src");
        document.dispatchEvent(new CustomEvent("cc:scroll-lock", {detail: false}));
        opener?.focus();
    });
}
